export default {
      id: "icon-heart-red-usage",
      viewBox: "0 0 21 18",
      url: __webpack_public_path__ + "icons.svg#icon-heart-red",
      toString: function () {
        return this.url;
      }
    }